import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import { discoveryCustomers } from './newWayDiscoveriesConstants';

import './new_way.scss';

type Props = {
  carouselLimit: number;
};

type State = {
  currentSlide: number;
  backward: boolean;
};

export class NewWayDiscovery extends React.Component<Props, State> {
  static defaultProps = {
    carouselLimit: discoveryCustomers.length,
  };

  state: State = {
    currentSlide: 0,
    // eslint-disable-next-line
    backward: false,
  };

  nextSlide = () => {
    const { carouselLimit } = this.props;
    this.setState(({ currentSlide: prevSlide }) => ({
      currentSlide: (prevSlide + 1) % carouselLimit,
    }));
  };

  prevSlide = () => {
    const { carouselLimit } = this.props;
    this.setState(({ currentSlide: prevSlide }) => {
      const r = prevSlide - (1 % carouselLimit);
      return {
        currentSlide: r < 0 ? r + carouselLimit : r,
      };
    });
  };

  updateCurrentSlide = (index: number) => {
    const { currentSlide } = this.state;
    const { carouselLimit } = this.props;
    if (index !== currentSlide)
      this.setState(({ backward: prevBack, currentSlide: prevSlide }) => {
        let backward = prevBack;
        if (prevSlide === 0) {
          backward = false;
        }
        if (prevSlide === carouselLimit - 1) {
          backward = true;
        }

        return {
          backward,
          currentSlide: backward ? prevSlide - 1 : prevSlide + 1,
        };
      });
  };

  render() {
    const { currentSlide } = this.state;

    const {
      author: { name, job, city },
      title,
    } = discoveryCustomers[currentSlide];

    return (
      <div className="new-way__discovery__container">
        <Carousel
          selectedItem={currentSlide}
          onChange={this.updateCurrentSlide}
          showIndicators={false}
          showArrows={false}
          showStatus={false}
          showThumbs={false}
          emulateTouch
          infiniteLoop
          autoPlay
          interval={5000}
        >
          {discoveryCustomers.map(({ carousel }) => (
            <img
              className="new-way__discovery__carousel_img"
              key={carousel}
              src={carousel}
              alt={carousel}
            />
          ))}
        </Carousel>
        <div className="new-way__discovery__panel">
          <div className="new-way__discovery__panel__text">
            <p className="new-way__discovery__panel__text__title">{title}</p>
            <p className="new-way__discovery__panel__text__legend">{`${name} - ${job} - ${city}`}</p>
          </div>
          <div className="new-way__discovery__panel__arrows">
            <span className="new-way__discovery__panel__arrows__container">
              <i
                onClick={this.prevSlide}
                className="new-way__discovery__panel__arrows__icons material-icons icons__keyboard_arrow_left"
              />
              <i
                onClick={this.nextSlide}
                className="new-way__discovery__panel__arrows__icons material-icons icons__keyboard_arrow_right"
              />
            </span>
          </div>
        </div>
      </div>
    );
  }
}
